/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddInstituteHeaderRequest,
  AddressRequest,
  ApiError,
  CreateInstituteRoom,
  HealthProResponse,
  Institute,
  InstituteAddress,
  InstituteEmail,
  InstituteEmailRequest,
  InstituteHeader,
  InstituteInformation,
  InstitutePhone,
  InstitutePhoneRequest,
  InstituteSlug,
  LastPatientsResponse,
  PersonLightResponse,
  UpdateInstituteHeaderRequest,
  UpdateInstituteRequest,
  UpdateInstituteRoom,
  UpdateInstituteSlug,
  UpdateUsersPermissionsRequest,
  UpsertInstituteInformation,
  UsersPermissions,
  WaitingPatientsResponse,
  WaitingRoomResponse,
} from '../models/index';
import {
    AddInstituteHeaderRequestFromJSON,
    AddInstituteHeaderRequestToJSON,
    AddressRequestFromJSON,
    AddressRequestToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateInstituteRoomFromJSON,
    CreateInstituteRoomToJSON,
    HealthProResponseFromJSON,
    HealthProResponseToJSON,
    InstituteFromJSON,
    InstituteToJSON,
    InstituteAddressFromJSON,
    InstituteAddressToJSON,
    InstituteEmailFromJSON,
    InstituteEmailToJSON,
    InstituteEmailRequestFromJSON,
    InstituteEmailRequestToJSON,
    InstituteHeaderFromJSON,
    InstituteHeaderToJSON,
    InstituteInformationFromJSON,
    InstituteInformationToJSON,
    InstitutePhoneFromJSON,
    InstitutePhoneToJSON,
    InstitutePhoneRequestFromJSON,
    InstitutePhoneRequestToJSON,
    InstituteSlugFromJSON,
    InstituteSlugToJSON,
    LastPatientsResponseFromJSON,
    LastPatientsResponseToJSON,
    PersonLightResponseFromJSON,
    PersonLightResponseToJSON,
    UpdateInstituteHeaderRequestFromJSON,
    UpdateInstituteHeaderRequestToJSON,
    UpdateInstituteRequestFromJSON,
    UpdateInstituteRequestToJSON,
    UpdateInstituteRoomFromJSON,
    UpdateInstituteRoomToJSON,
    UpdateInstituteSlugFromJSON,
    UpdateInstituteSlugToJSON,
    UpdateUsersPermissionsRequestFromJSON,
    UpdateUsersPermissionsRequestToJSON,
    UpsertInstituteInformationFromJSON,
    UpsertInstituteInformationToJSON,
    UsersPermissionsFromJSON,
    UsersPermissionsToJSON,
    WaitingPatientsResponseFromJSON,
    WaitingPatientsResponseToJSON,
    WaitingRoomResponseFromJSON,
    WaitingRoomResponseToJSON,
} from '../models/index';

export interface AddHeaderToIwrRequest {
    instituteId: string;
    addInstituteHeaderRequest: AddInstituteHeaderRequest;
}

export interface AddRoomToInstituteAddressRequest {
    instituteId: string;
    createInstituteRoom: CreateInstituteRoom;
}

export interface CreateAddressByInstituteRequest {
    instituteId: string;
    instituteAddress: InstituteAddress;
}

export interface DeleteAddressByInstituteRequest {
    instituteId: string;
    addressId: string;
}

export interface DeleteEmailByInstituteRequest {
    instituteId: string;
    emailId: string;
}

export interface DeleteIwrHeaderRequest {
    instituteId: string;
    headerId: string;
}

export interface DeletePhoneByInstituteRequest {
    instituteId: string;
    phoneId: string;
}

export interface DeleteRoomRequest {
    instituteId: string;
    roomId: string;
}

export interface GetHealthProDelegatePermissionByUserRequest {
    instituteId: string;
}

export interface GetInstituteRequest {
    instituteId: string;
    joinHealthPros?: boolean;
}

export interface GetInstituteInformationRequest {
    instituteId: string;
}

export interface GetInstituteSlugRequest {
    instituteId: string;
}

export interface GetPermissionsByUsersRequest {
    instituteId: string;
    personId: string;
}

export interface GetStudentsByInstituteRequest {
    instituteId: string;
}

export interface ListAddressesByInstituteRequest {
    instituteId: string;
}

export interface ListEmailsByInstituteRequest {
    instituteId: string;
}

export interface ListHeadersByInstituteRequest {
    instituteId: string;
}

export interface ListLastPatientsByInstituteRequest {
    instituteId: string;
    specificDate?: string;
}

export interface ListPhonesByInstituteRequest {
    instituteId: string;
}

export interface ListRoomsByInstituteRequest {
    instituteId: string;
    withTemporary?: boolean;
}

export interface ListWaitingPatientsByInstituteRequest {
    instituteId: string;
}

export interface UpdateAddressByInstituteRequest {
    instituteId: string;
    addressId: string;
    addressRequest: AddressRequest;
}

export interface UpdateEmailByInstituteRequest {
    instituteId: string;
    emailId: string;
    instituteEmailRequest: InstituteEmailRequest;
}

export interface UpdateInsituteRequest {
    instituteId: string;
    updateInstituteRequest: UpdateInstituteRequest;
}

export interface UpdateInstituteSlugRequest {
    instituteId: string;
    updateInstituteSlug: UpdateInstituteSlug;
}

export interface UpdateIwrHeaderRequest {
    instituteId: string;
    headerId: string;
    updateInstituteHeaderRequest: UpdateInstituteHeaderRequest;
}

export interface UpdatePermissionRequest {
    instituteId: string;
    personId: string;
    updateUsersPermissionsRequest: UpdateUsersPermissionsRequest;
}

export interface UpdatePhoneByInstituteRequest {
    instituteId: string;
    phoneId: string;
    institutePhoneRequest: InstitutePhoneRequest;
}

export interface UpdateRoomRequest {
    instituteId: string;
    roomId: string;
    updateInstituteRoom: UpdateInstituteRoom;
}

export interface UpsertInstituteInformationRequest {
    instituteId: string;
    upsertInstituteInformation: UpsertInstituteInformation;
}

/**
 * 
 */
export class InstituteApi extends runtime.BaseAPI {

    /**
     * Add a header to an institute
     */
    async addHeaderToIwrRaw(requestParameters: AddHeaderToIwrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstituteHeader>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling addHeaderToIwr().'
            );
        }

        if (requestParameters['addInstituteHeaderRequest'] == null) {
            throw new runtime.RequiredError(
                'addInstituteHeaderRequest',
                'Required parameter "addInstituteHeaderRequest" was null or undefined when calling addHeaderToIwr().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/headers`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddInstituteHeaderRequestToJSON(requestParameters['addInstituteHeaderRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstituteHeaderFromJSON(jsonValue));
    }

    /**
     * Add a header to an institute
     */
    async addHeaderToIwr(requestParameters: AddHeaderToIwrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstituteHeader> {
        const response = await this.addHeaderToIwrRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a waiting room to an institute
     */
    async addRoomToInstituteAddressRaw(requestParameters: AddRoomToInstituteAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WaitingRoomResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling addRoomToInstituteAddress().'
            );
        }

        if (requestParameters['createInstituteRoom'] == null) {
            throw new runtime.RequiredError(
                'createInstituteRoom',
                'Required parameter "createInstituteRoom" was null or undefined when calling addRoomToInstituteAddress().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/rooms`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateInstituteRoomToJSON(requestParameters['createInstituteRoom']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WaitingRoomResponseFromJSON(jsonValue));
    }

    /**
     * Add a waiting room to an institute
     */
    async addRoomToInstituteAddress(requestParameters: AddRoomToInstituteAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WaitingRoomResponse> {
        const response = await this.addRoomToInstituteAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an address of an institute
     */
    async createAddressByInstituteRaw(requestParameters: CreateAddressByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstituteAddress>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling createAddressByInstitute().'
            );
        }

        if (requestParameters['instituteAddress'] == null) {
            throw new runtime.RequiredError(
                'instituteAddress',
                'Required parameter "instituteAddress" was null or undefined when calling createAddressByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/addresses`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InstituteAddressToJSON(requestParameters['instituteAddress']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstituteAddressFromJSON(jsonValue));
    }

    /**
     * Create an address of an institute
     */
    async createAddressByInstitute(requestParameters: CreateAddressByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstituteAddress> {
        const response = await this.createAddressByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete address of an institute
     */
    async deleteAddressByInstituteRaw(requestParameters: DeleteAddressByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling deleteAddressByInstitute().'
            );
        }

        if (requestParameters['addressId'] == null) {
            throw new runtime.RequiredError(
                'addressId',
                'Required parameter "addressId" was null or undefined when calling deleteAddressByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/addresses/{address_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"address_id"}}`, encodeURIComponent(String(requestParameters['addressId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete address of an institute
     */
    async deleteAddressByInstitute(requestParameters: DeleteAddressByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAddressByInstituteRaw(requestParameters, initOverrides);
    }

    /**
     * Delete email of an institute
     */
    async deleteEmailByInstituteRaw(requestParameters: DeleteEmailByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling deleteEmailByInstitute().'
            );
        }

        if (requestParameters['emailId'] == null) {
            throw new runtime.RequiredError(
                'emailId',
                'Required parameter "emailId" was null or undefined when calling deleteEmailByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/emails/{email_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"email_id"}}`, encodeURIComponent(String(requestParameters['emailId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete email of an institute
     */
    async deleteEmailByInstitute(requestParameters: DeleteEmailByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEmailByInstituteRaw(requestParameters, initOverrides);
    }

    /**
     * Delete an institute header
     */
    async deleteIwrHeaderRaw(requestParameters: DeleteIwrHeaderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling deleteIwrHeader().'
            );
        }

        if (requestParameters['headerId'] == null) {
            throw new runtime.RequiredError(
                'headerId',
                'Required parameter "headerId" was null or undefined when calling deleteIwrHeader().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/headers/{header_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"header_id"}}`, encodeURIComponent(String(requestParameters['headerId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an institute header
     */
    async deleteIwrHeader(requestParameters: DeleteIwrHeaderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteIwrHeaderRaw(requestParameters, initOverrides);
    }

    /**
     * Delete phone of an institute
     */
    async deletePhoneByInstituteRaw(requestParameters: DeletePhoneByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling deletePhoneByInstitute().'
            );
        }

        if (requestParameters['phoneId'] == null) {
            throw new runtime.RequiredError(
                'phoneId',
                'Required parameter "phoneId" was null or undefined when calling deletePhoneByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/phones/{phone_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"phone_id"}}`, encodeURIComponent(String(requestParameters['phoneId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete phone of an institute
     */
    async deletePhoneByInstitute(requestParameters: DeletePhoneByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePhoneByInstituteRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a waiting room
     */
    async deleteRoomRaw(requestParameters: DeleteRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling deleteRoom().'
            );
        }

        if (requestParameters['roomId'] == null) {
            throw new runtime.RequiredError(
                'roomId',
                'Required parameter "roomId" was null or undefined when calling deleteRoom().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/rooms/{roomId}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters['roomId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a waiting room
     */
    async deleteRoom(requestParameters: DeleteRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteRoomRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve all health pro with delegate permission allowed for current user
     */
    async getHealthProDelegatePermissionByUserRaw(requestParameters: GetHealthProDelegatePermissionByUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PersonLightResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getHealthProDelegatePermissionByUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/health-pro/delegate-permissions`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PersonLightResponseFromJSON));
    }

    /**
     * Retrieve all health pro with delegate permission allowed for current user
     */
    async getHealthProDelegatePermissionByUser(requestParameters: GetHealthProDelegatePermissionByUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PersonLightResponse>> {
        const response = await this.getHealthProDelegatePermissionByUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve an institute
     */
    async getInstituteRaw(requestParameters: GetInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Institute>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['joinHealthPros'] != null) {
            queryParameters['joinHealthPros'] = requestParameters['joinHealthPros'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstituteFromJSON(jsonValue));
    }

    /**
     * Retrieve an institute
     */
    async getInstitute(requestParameters: GetInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Institute> {
        const response = await this.getInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Institute Information from portal api
     */
    async getInstituteInformationRaw(requestParameters: GetInstituteInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstituteInformation>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getInstituteInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/information`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstituteInformationFromJSON(jsonValue));
    }

    /**
     * Get Institute Information from portal api
     */
    async getInstituteInformation(requestParameters: GetInstituteInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstituteInformation> {
        const response = await this.getInstituteInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get an institute\'s slug
     */
    async getInstituteSlugRaw(requestParameters: GetInstituteSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstituteSlug>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getInstituteSlug().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/slug`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstituteSlugFromJSON(jsonValue));
    }

    /**
     * Get an institute\'s slug
     */
    async getInstituteSlug(requestParameters: GetInstituteSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstituteSlug> {
        const response = await this.getInstituteSlugRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all permissions of users in an institutes
     */
    async getPermissionsByUsersRaw(requestParameters: GetPermissionsByUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UsersPermissions>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getPermissionsByUsers().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getPermissionsByUsers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/permissions/by-user/{person_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UsersPermissionsFromJSON));
    }

    /**
     * Retrieve all permissions of users in an institutes
     */
    async getPermissionsByUsers(requestParameters: GetPermissionsByUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UsersPermissions>> {
        const response = await this.getPermissionsByUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all students by institute
     */
    async getStudentsByInstituteRaw(requestParameters: GetStudentsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HealthProResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getStudentsByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/students`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HealthProResponseFromJSON));
    }

    /**
     * Get all students by institute
     */
    async getStudentsByInstitute(requestParameters: GetStudentsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HealthProResponse>> {
        const response = await this.getStudentsByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all addresses associated with a specific medical institute.
     * List all addresses of an institute
     */
    async listAddressesByInstituteRaw(requestParameters: ListAddressesByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InstituteAddress>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling listAddressesByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/addresses`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InstituteAddressFromJSON));
    }

    /**
     * Retrieve all addresses associated with a specific medical institute.
     * List all addresses of an institute
     */
    async listAddressesByInstitute(requestParameters: ListAddressesByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InstituteAddress>> {
        const response = await this.listAddressesByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all emails associated with a specific medical institute.
     * List all emails of an institute
     */
    async listEmailsByInstituteRaw(requestParameters: ListEmailsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InstituteEmail>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling listEmailsByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/emails`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InstituteEmailFromJSON));
    }

    /**
     * Retrieve all emails associated with a specific medical institute.
     * List all emails of an institute
     */
    async listEmailsByInstitute(requestParameters: ListEmailsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InstituteEmail>> {
        const response = await this.listEmailsByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all headers associated with a specific medical institute.
     * List all headers of an institute
     */
    async listHeadersByInstituteRaw(requestParameters: ListHeadersByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InstituteHeader>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling listHeadersByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/headers`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InstituteHeaderFromJSON));
    }

    /**
     * Retrieve all headers associated with a specific medical institute.
     * List all headers of an institute
     */
    async listHeadersByInstitute(requestParameters: ListHeadersByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InstituteHeader>> {
        const response = await this.listHeadersByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all patients with relation entry for a specific date
     */
    async listLastPatientsByInstituteRaw(requestParameters: ListLastPatientsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LastPatientsResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling listLastPatientsByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['specificDate'] != null) {
            queryParameters['specificDate'] = requestParameters['specificDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/last-patients`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LastPatientsResponseFromJSON));
    }

    /**
     * List all patients with relation entry for a specific date
     */
    async listLastPatientsByInstitute(requestParameters: ListLastPatientsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LastPatientsResponse>> {
        const response = await this.listLastPatientsByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all phones associated with a specific medical institute.
     * List all phones of an institute
     */
    async listPhonesByInstituteRaw(requestParameters: ListPhonesByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InstitutePhone>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling listPhonesByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/phones`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InstitutePhoneFromJSON));
    }

    /**
     * Retrieve all phones associated with a specific medical institute.
     * List all phones of an institute
     */
    async listPhonesByInstitute(requestParameters: ListPhonesByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InstitutePhone>> {
        const response = await this.listPhonesByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all waiting rooms of an institute
     */
    async listRoomsByInstituteRaw(requestParameters: ListRoomsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WaitingRoomResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling listRoomsByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['withTemporary'] != null) {
            queryParameters['withTemporary'] = requestParameters['withTemporary'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/rooms`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WaitingRoomResponseFromJSON));
    }

    /**
     * List all waiting rooms of an institute
     */
    async listRoomsByInstitute(requestParameters: ListRoomsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WaitingRoomResponse>> {
        const response = await this.listRoomsByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all patients currently having an appointment, organized by waiting room
     */
    async listWaitingPatientsByInstituteRaw(requestParameters: ListWaitingPatientsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WaitingPatientsResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling listWaitingPatientsByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/waiting-patients`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WaitingPatientsResponseFromJSON));
    }

    /**
     * List all patients currently having an appointment, organized by waiting room
     */
    async listWaitingPatientsByInstitute(requestParameters: ListWaitingPatientsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WaitingPatientsResponse>> {
        const response = await this.listWaitingPatientsByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update address of an institute
     */
    async updateAddressByInstituteRaw(requestParameters: UpdateAddressByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstituteAddress>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateAddressByInstitute().'
            );
        }

        if (requestParameters['addressId'] == null) {
            throw new runtime.RequiredError(
                'addressId',
                'Required parameter "addressId" was null or undefined when calling updateAddressByInstitute().'
            );
        }

        if (requestParameters['addressRequest'] == null) {
            throw new runtime.RequiredError(
                'addressRequest',
                'Required parameter "addressRequest" was null or undefined when calling updateAddressByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/addresses/{address_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"address_id"}}`, encodeURIComponent(String(requestParameters['addressId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddressRequestToJSON(requestParameters['addressRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstituteAddressFromJSON(jsonValue));
    }

    /**
     * Update address of an institute
     */
    async updateAddressByInstitute(requestParameters: UpdateAddressByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstituteAddress> {
        const response = await this.updateAddressByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update email of an institute
     */
    async updateEmailByInstituteRaw(requestParameters: UpdateEmailByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstituteEmail>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateEmailByInstitute().'
            );
        }

        if (requestParameters['emailId'] == null) {
            throw new runtime.RequiredError(
                'emailId',
                'Required parameter "emailId" was null or undefined when calling updateEmailByInstitute().'
            );
        }

        if (requestParameters['instituteEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'instituteEmailRequest',
                'Required parameter "instituteEmailRequest" was null or undefined when calling updateEmailByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/emails/{email_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"email_id"}}`, encodeURIComponent(String(requestParameters['emailId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InstituteEmailRequestToJSON(requestParameters['instituteEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstituteEmailFromJSON(jsonValue));
    }

    /**
     * Update email of an institute
     */
    async updateEmailByInstitute(requestParameters: UpdateEmailByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstituteEmail> {
        const response = await this.updateEmailByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update institute information
     */
    async updateInsituteRaw(requestParameters: UpdateInsituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateInsitute().'
            );
        }

        if (requestParameters['updateInstituteRequest'] == null) {
            throw new runtime.RequiredError(
                'updateInstituteRequest',
                'Required parameter "updateInstituteRequest" was null or undefined when calling updateInsitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/data`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInstituteRequestToJSON(requestParameters['updateInstituteRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Update institute information
     */
    async updateInsitute(requestParameters: UpdateInsituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.updateInsituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an institute\'s slug
     */
    async updateInstituteSlugRaw(requestParameters: UpdateInstituteSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateInstituteSlug().'
            );
        }

        if (requestParameters['updateInstituteSlug'] == null) {
            throw new runtime.RequiredError(
                'updateInstituteSlug',
                'Required parameter "updateInstituteSlug" was null or undefined when calling updateInstituteSlug().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/slug`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInstituteSlugToJSON(requestParameters['updateInstituteSlug']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update an institute\'s slug
     */
    async updateInstituteSlug(requestParameters: UpdateInstituteSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateInstituteSlugRaw(requestParameters, initOverrides);
    }

    /**
     * Update an institute header
     */
    async updateIwrHeaderRaw(requestParameters: UpdateIwrHeaderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstituteHeader>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateIwrHeader().'
            );
        }

        if (requestParameters['headerId'] == null) {
            throw new runtime.RequiredError(
                'headerId',
                'Required parameter "headerId" was null or undefined when calling updateIwrHeader().'
            );
        }

        if (requestParameters['updateInstituteHeaderRequest'] == null) {
            throw new runtime.RequiredError(
                'updateInstituteHeaderRequest',
                'Required parameter "updateInstituteHeaderRequest" was null or undefined when calling updateIwrHeader().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/headers/{header_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"header_id"}}`, encodeURIComponent(String(requestParameters['headerId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInstituteHeaderRequestToJSON(requestParameters['updateInstituteHeaderRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstituteHeaderFromJSON(jsonValue));
    }

    /**
     * Update an institute header
     */
    async updateIwrHeader(requestParameters: UpdateIwrHeaderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstituteHeader> {
        const response = await this.updateIwrHeaderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a permission
     */
    async updatePermissionRaw(requestParameters: UpdatePermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updatePermission().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updatePermission().'
            );
        }

        if (requestParameters['updateUsersPermissionsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateUsersPermissionsRequest',
                'Required parameter "updateUsersPermissionsRequest" was null or undefined when calling updatePermission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/permissions/by-user/{person_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUsersPermissionsRequestToJSON(requestParameters['updateUsersPermissionsRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Update a permission
     */
    async updatePermission(requestParameters: UpdatePermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.updatePermissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update phone of an institute
     */
    async updatePhoneByInstituteRaw(requestParameters: UpdatePhoneByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstitutePhone>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updatePhoneByInstitute().'
            );
        }

        if (requestParameters['phoneId'] == null) {
            throw new runtime.RequiredError(
                'phoneId',
                'Required parameter "phoneId" was null or undefined when calling updatePhoneByInstitute().'
            );
        }

        if (requestParameters['institutePhoneRequest'] == null) {
            throw new runtime.RequiredError(
                'institutePhoneRequest',
                'Required parameter "institutePhoneRequest" was null or undefined when calling updatePhoneByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/phones/{phone_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"phone_id"}}`, encodeURIComponent(String(requestParameters['phoneId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InstitutePhoneRequestToJSON(requestParameters['institutePhoneRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstitutePhoneFromJSON(jsonValue));
    }

    /**
     * Update phone of an institute
     */
    async updatePhoneByInstitute(requestParameters: UpdatePhoneByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstitutePhone> {
        const response = await this.updatePhoneByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a waiting room
     */
    async updateRoomRaw(requestParameters: UpdateRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WaitingRoomResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateRoom().'
            );
        }

        if (requestParameters['roomId'] == null) {
            throw new runtime.RequiredError(
                'roomId',
                'Required parameter "roomId" was null or undefined when calling updateRoom().'
            );
        }

        if (requestParameters['updateInstituteRoom'] == null) {
            throw new runtime.RequiredError(
                'updateInstituteRoom',
                'Required parameter "updateInstituteRoom" was null or undefined when calling updateRoom().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/rooms/{roomId}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters['roomId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInstituteRoomToJSON(requestParameters['updateInstituteRoom']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WaitingRoomResponseFromJSON(jsonValue));
    }

    /**
     * Update a waiting room
     */
    async updateRoom(requestParameters: UpdateRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WaitingRoomResponse> {
        const response = await this.updateRoomRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upsert institute information in the portal api
     */
    async upsertInstituteInformationRaw(requestParameters: UpsertInstituteInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstituteInformation>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling upsertInstituteInformation().'
            );
        }

        if (requestParameters['upsertInstituteInformation'] == null) {
            throw new runtime.RequiredError(
                'upsertInstituteInformation',
                'Required parameter "upsertInstituteInformation" was null or undefined when calling upsertInstituteInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/information`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertInstituteInformationToJSON(requestParameters['upsertInstituteInformation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstituteInformationFromJSON(jsonValue));
    }

    /**
     * Upsert institute information in the portal api
     */
    async upsertInstituteInformation(requestParameters: UpsertInstituteInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstituteInformation> {
        const response = await this.upsertInstituteInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
